// Format images on blog posts

if (window.location.href.includes("blogs")) {
  const articleLinks = document.querySelectorAll(
    ".article-template__content a"
  );
  if (articleLinks.length > 0) {
    articleLinks.forEach((link) => {
      if (link.querySelector("img")) {
        const parent = link.parentNode;
        parent?.classList.add("article-template__content--image");
      }
    });
  }
}


// Anchor navigation behavior
var anchorLinks = document.querySelectorAll('.anchor-link');
var stickyHeader = document.querySelector('sticky-header'); 
var anchorNavigation = document.querySelector('.anchor-navigation');
var annocementSlider = document.querySelector('announcement-slider');

// Hero slider buttons
var heroSliderButtons = document.querySelectorAll('hero-slider .button-group .button'); 

var headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
var anchorNavigationHeight = anchorNavigation ? anchorNavigation.offsetHeight : 0;
var annocementSliderHeight = annocementSlider ? annocementSlider.offsetHeight : 0;

anchorLinks.forEach(function(link) {
    link.addEventListener('click', scrollFunction);
});

heroSliderButtons.forEach(function(button) {
    button.addEventListener('click', scrollFunction);
});

function scrollFunction(e) {
  var targetId = this.getAttribute('href');
  
  // Check if href is an internal page anchor
  if (targetId.startsWith('#')) {
      e.preventDefault();

      var targetElement = document.querySelector(targetId);
      if (targetElement) {
          var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - anchorNavigationHeight - annocementSliderHeight;
          window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
          });
      }
  } 
}

const sizeGuideTrigger = document.querySelector(".size-guide-trigger");
const sizeGuideClose = document.querySelector(".size-guide-close");
const body = document.body;

if(sizeGuideTrigger) {
  sizeGuideTrigger.addEventListener("click", function() {
    body.classList.add("body-no-scroll");
  });
}

if(sizeGuideClose) {
  sizeGuideClose.addEventListener("click", function() {
    body.classList.remove("body-no-scroll");
  });
}

document.addEventListener('rebuy:cart.change', (event) => {
  const items = event.detail.cart.cart.items;
  const sum = items.reduce((acc, item) => acc + item.quantity, 0);
  document.querySelector('.cart-count-bubble > span:first-child').innerHTML = sum;
  runRebuyCode(event.detail.cart.cart);
});

function getSplitCharacter(cart) {
  if(cart.currency == "DKK") {
    return ",";
  }

  return ".";
}

function adjustRebuyContent() {
  setTimeout(() => {
    const paymentIcons = document.querySelector('.payment__icons-footer-template');
    const belowCheckout = document.querySelector('.rebuy-cart div[data-app-target="below_checkout"]');
        
    if (belowCheckout && paymentIcons) {
      const existingPaymentIcons = belowCheckout.querySelector('.payment__icons-footer-template');

      if (existingPaymentIcons) {
        existingPaymentIcons.remove();
      }

      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      belowCheckout.appendChild(clonedPaymentIcons);
    }
  }, 500);
}


function runRebuyCode(cart) {
  setTimeout(() => {  
    const items = cart.items;
    const rebuyText = document.getElementById('rebuy-cart__progress-bar-meter-label');
    if (items.length == 0 && rebuyText) {
      const splitCharacter = getSplitCharacter(cart);
      const rebuyTextFirst = rebuyText.innerHTML.split(splitCharacter)[0];
      rebuyText.innerHTML = rebuyTextFirst
    }
  }, 100);
}

document.addEventListener('rebuy:smartcart.ready', (event) => {
  adjustRebuyContent();
});
 
document.addEventListener('rebuy:smartcart.show', (event) => {
  runRebuyCode(event.detail.smartcart.cart)
});

if(location.pathname.includes('/collections')) {
  [...document.querySelectorAll('.collection-list__item.grid__item')].forEach(item => {
      const content = item.querySelector('.card__content')
      if(!content) {
          item.remove()
      }    
  })
}